<template>
  <div class="industry-bidding-01 width-100 default-border mb--10 Substation">
    <slot name="title">
      <div class="side-moulde-title">
        <span class="text">千里马分站</span>
      </div>
    </slot>
    <div class="con-block side-moulde-con">
      <div v-for="item in substation" :key="item.id" class="single f-layout mt--10 mb--20">
        <div class="area-block">
          <img :src="`${imgPath}/oneold/layout/caigouabg.gif`" alt="" class="triangle-img" />
          <span class="area-text">{{ item.area }}</span>
        </div>
        <div>
          <a
            v-for="sitem in item.city"
            :key="sitem.id"
            :href="indexUrl + sitem.url"
             :title="sitem.text+'招标网'"
            target="_blank"
            class="hover-text_theme city-single-a"
            >{{ sitem.text }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imgPath, INDEX_URL_GJXX } from "@/utils/constants/constants";
import { substation } from "@/utils/constants/gjxx_bidding_data";
export default {
  name: "Substation",
  components: {},
  data() {
    return {
      username: "",
      imgPath,
      pageType: "hot",
      substation: [],
      indexUrl: INDEX_URL_GJXX,
    };
  },
  computed: {},
  created() {
    this.substation = substation;
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.Substation {
  .area-block {
    font-weight: bolder;
    width: 50px;
    img {
      margin-right: 6px;
    }
  }

  .city-single-a {
    margin-right: 8px;
  }
}
</style>
